import React, { useEffect, useState } from "react";
import Slider from "react-slick";  // Import Slider from react-slick
import axios from 'axios';
import config from "../includes/ConfigFile";

const HomeSlider = () => {

    // Get Dynamic Slider code start
    const [sliderData, setsliderData] = useState([]);

    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/slider`)
            .then(response => {
                //console.log('Fetched data:', response.data); // Log the fetched data
                setsliderData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);
    // Get Dynamic Category code end

    const infiniteSetting = sliderData.length > 1;
    const settings = {
        dots: false,
        infinite: infiniteSetting,
        speed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };
    return (
        <>
            <div className="home-container">
                {/* <div className="slider-item">
                        <img src={`${process.env.PUBLIC_URL}/uploads/slider/slider_1.jpg`} alt="Banner 1" />
                        <div className="slider-content">
                            <h2>Slide Title 1</h2>
                            <p>This is the description for slide 1.</p>
                            <button>Learn More</button>
                        </div>
                    </div> */}
                <Slider {...settings}>
                    
                    {sliderData.map((slide, index) => (
                        <div key={index} className="slider-item">
                            <img src={`${config.BASE_URL}/public/uploads/admin/slider_image/${slide.slider_image}`} alt={`Slide ${index + 1}`} />
                            {/* <div className="slide-content">
                                <h2>{slide.slider_title}</h2>
                                <p>{slide.slider_description}</p>
                                <button>Learn More</button>
                            </div> */}
                        </div>
                    ))}
                </Slider>
            </div>
        </>
    )
};

export default HomeSlider;